import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What age group do you work with?",
    a: "At Shunya Child Development Center, we work with children from infancy to adolescence (0–18 years). Our therapy and intervention programs are personalized according to each child's developmental needs and goals.",
  },
  {
    q: "Do I need a referral from a pediatrician?",
    a: "No, a referral is not mandatory. Parents can directly book an assessment with us. However, if your child has been referred by a pediatrician, neurologist, psychologist, or another healthcare professional, you are welcome to bring the referral and any relevant reports.",
  },
  {
    q: "How long is a typical therapy session?",
    a: "A typical therapy session lasts 45–60 minutes, depending on the child's age, attention span, and therapy goals. Session duration may vary based on individual needs.",
  },
  {
    q: "What should we bring to the first consultation?",
    a: "Please bring any previous medical reports, assessment reports, therapy records, hearing or vision reports (if available), school reports, and a list of your child's current concerns. These help us understand your child's needs better and plan the most effective intervention.",
  },
  {
    q: "Do you offer parent coaching and home programs?",
    a: "Yes. We strongly believe that parents play an important role in their child's development. We provide parent guidance, home practice activities, and regular feedback so that therapy continues beyond the clinic and progress is maximized.",
  },
  {
    q: "How is progress measured?",
    a: "Your child's progress is monitored through regular assessments, therapy goals, clinical observations, and parent feedback. We review progress periodically, update therapy goals when needed, and keep families informed throughout the intervention process.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="scroll-mt-20 py-20 lg:py-28 bg-white"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#0055FF]">
            FAQ
          </div>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0A192F] tracking-tight">
            Answers to common questions.
          </h2>
        </div>
        <Accordion type="single" collapsible className="mt-12">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-[#E2E8F0]"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-heading text-lg font-medium text-[#0A192F] hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#475569] leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
